import { LoadersNames, PopupNames, PopupState } from './types';

import { AppState } from '../store';

const popup = (state: AppState, name: PopupNames): PopupState => state.ui[name];

export const popupByName = (name: PopupNames) => (state: AppState) => popup(state, name);

const loaders = (state: AppState, name: LoadersNames): boolean => state.ui.loaders[name as string];

export const loadersByName = (name: LoadersNames) => (state: AppState) => loaders(state, name);

export const errors = (state: AppState): Record<string, unknown | string> => state.ui.errors;

export const notices = (state: AppState): Record<string, unknown | string> => state.ui.notices;

export const urlHistory = (state: AppState): string[] => state.ui.urlHistory;

export const storeLocale = (state: AppState): string => state.intl.locale;
